import React from "react";
import IMG from "../../../assets/bim/img3.png";
export default function Image3() {
  return (
    <div className="w-full bg-black flex justify-center pb-20">
      <img src={IMG} alt="bim" className="w-full px-20 max-w-screen-2xl" />
    </div>
  );
}
